import React, { useCallback } from 'react'

import { TabList, Tab, TabContent } from 'Components/shared/Tabs'
import { navigate } from 'raviger'
import VirtualOffices from './Tabs/VirtualOffices'
import Users from './Tabs/Users'

const tabs = ['virtual-offices', 'users']

export default ({ tab }) => {
  const activeTab = tabs.indexOf(tab)
  const setActiveTab = useCallback(tabIndex => navigate(`/admin/${tabs[tabIndex]}`))
  return (
    <>
      <TabList activeTab={activeTab} setActiveTab={setActiveTab} xAlign="stretch">
        {/* TODO: Fix this horrific thing somehow */}
        {/* TODO: Fix middle clicking */}
        <Tab style={{ flexGrow: 1 }}>VIRTUAL OFFICES</Tab>
        <Tab style={{ flexGrow: 1 }}>USERS</Tab>
      </TabList>

      {tabs[activeTab] === 'virtual-offices' && (
        <TabContent xAlign>
          <VirtualOffices />
        </TabContent>
      )}
      {tabs[activeTab] === 'users' && (
        <TabContent xAlign>
          <Users />
        </TabContent>
      )}
    </>
  )
}
